import { z } from '../utils/zod.js';
import { dataResponse } from '../utils/response-templates.js';
import { adminOrganizationCompactSchema, adminUserCompactSchema, adminUserRoleSchema, adminUserStateSchema, } from './compact.js';
import { adminBooleanQuerySchema, adminPageResponse, adminPaginationQuerySchema } from './pagination.js';
export const adminUserIdParamsSchema = z.object({
    userId: z.string().uuid(),
});
export const adminUserDtoSchema = z.object({
    id: z.string().uuid(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    email: z.string(),
    name: z.string(),
    phone: z.string().nullable(),
    language: z.string(),
    role: adminUserRoleSchema,
    state: adminUserStateSchema,
    emailVerifiedAt: z.string().datetime().nullable(),
    phoneVerified: z.boolean(),
    termsAcceptedAt: z.string().datetime().nullable(),
    kycProvider: z.string().nullable(),
    kycPresent: z.boolean(),
    shadowBanned: z.boolean(),
    externalProvider: z.string().nullable(),
    organization: adminOrganizationCompactSchema.nullable(),
    ownedOrganizationId: z.string().uuid().nullable(),
    apiKeysCount: z.number().int(),
});
export const adminUserResponseSchema = dataResponse(adminUserDtoSchema);
export const adminListUsersQuerySchema = adminPaginationQuerySchema.extend({
    email: z.string().trim().min(1).max(255).optional(),
    state: adminUserStateSchema.optional(),
    organizationId: z.string().uuid().optional(),
    shadowBanned: adminBooleanQuerySchema.optional(),
});
export const adminListUsersResponseSchema = adminPageResponse(adminUserCompactSchema);
